import React from "react";
import { Container } from "@mui/material";

const DSContainer = (props: React.ComponentProps<typeof Container>) => {
  return <Container {...props} />;
};

export default DSContainer;
